import { PageLayout, SuspenseWithSentryErrorBoundary } from '@retail/components';
import { Paper } from '@shared/components';
import { CentralAssortmentContainer } from '@retail/my-assortment/containers';

export function CentralAssortmentPage() {
  return (
    <PageLayout maxWidth="full" fixedHeight spacing={2}>
      <Paper sx={{ display: 'flex', flexDirection: 'column', p: 0, height: '100%' }}>
        <SuspenseWithSentryErrorBoundary>
          <CentralAssortmentContainer />
        </SuspenseWithSentryErrorBoundary>
      </Paper>
    </PageLayout>
  );
}
